import { Component, inject, OnInit } from '@angular/core';
import { RssFeedService } from '../../services/rss-feed.service';
import { takeUntil } from 'rxjs';
import { NewsCardComponent } from '../../components/news-card/news-card.component';
import { NewsNoFeedComponent } from '../../components/news-no-feed/news-no-feed.component';

import { BaseComponent } from '../../../../components/core/components/base/base.component';
import { RssFeed } from '../../../../data-access/models/rss-feed.model';
import { ProfileResponse } from '../../../../data-access/models/profile-response.model';
import { EIntrackEventName } from '../../../../components/core/models/intrack-event-name.enum';
import { HOME_ROUTE } from '../../../../data-access/constants/app-routes';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { NgxEventTrackerService } from '@digipay/ngx-event-tracker';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';
import { NgForOf } from '@angular/common';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  imports: [NewsCardComponent, NewsNoFeedComponent, NgxAppBarComponent, SpinnerComponent, NgForOf],
  standalone: true,
})
export class NewsComponent extends BaseComponent implements OnInit {
  activeTab = 0;
  feed: RssFeed[] = [];
  isLoading = false;
  userProfile!: ProfileResponse;
  backIcon = true;
  private rssFeedService = inject(RssFeedService);
  private navigationService = inject(WealthNavigationService);
  private eventService = inject(NgxEventTrackerService);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.eventService.sendEvent({ eventName: EIntrackEventName.NEWS_PAGE_VIEW, eventData: {} });
    this.loadFeed();
  }

  loadFeed() {
    this.isLoading = true;
    this.rssFeedService
      .getFeed()
      .pipe(takeUntil(this.destroyObservable))
      .subscribe((res) => {
        if (res?.success) {
          this.feed = res.result;
        }
        this.isLoading = false;
      });
  }

  onBackHandler() {
    this.navigationService.navigate([HOME_ROUTE]);
  }
}
